import { useState } from 'react'
import { Button } from '../../components/ui/Button'
import { Modal } from '../../components/ui/Modal'
import { useAuthStore } from '../../store/authStore'
import { useTutorial } from './tutorialContext'
import { useAtualizarOnboarding, useOnboarding } from './useOnboarding'

/** Convite do primeiro login: aparece uma vez por sessão, só para conta elegível que ainda não respondeu. */
export function ConviteOnboarding() {
  const userName = useAuthStore((s) => s.userName)
  const { data } = useOnboarding()
  const atualizar = useAtualizarOnboarding()
  const { iniciarTutorial } = useTutorial()
  const [fechado, setFechado] = useState(false)

  const aberto = !fechado && !!data && data.elegivelConvite && !data.estado.conviteResposta

  function responder(resposta: 'comecar' | 'agora_nao') {
    setFechado(true)
    atualizar.mutate({ conviteResposta: resposta })
    if (resposta === 'comecar') iniciarTutorial('primeiros-passos')
  }

  return (
    <Modal
      open={aberto}
      onClose={() => setFechado(true)}
      title={`Olá, ${userName?.split(' ')[0] ?? 'bem-vindo'}!`}
      size="sm"
      footer={
        <>
          <Button variant="light" onClick={() => responder('agora_nao')}>Agora não</Button>
          <Button icon="ri-play-circle-line" onClick={() => responder('comecar')}>Começar</Button>
        </>
      }
    >
      <div className="text-center">
        <span className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-3xl text-primary">
          <i className="ri-sparkling-2-line" aria-hidden />
        </span>
        <h4 className="text-lg font-semibold text-white">Bem-vindo ao Walleon!</h4>
        <p className="mt-2 text-13 text-muted">
          Quer um guia na configuração básica? Conta, saldo, cartão, categorias e orçamento, em poucos passos.
          Você pode pular quando quiser e retomar depois em Tutoriais.
        </p>
      </div>
    </Modal>
  )
}
